<div class="progress-bar-container">
    <div 
        class="progress-bar-fill" 
        [style.width.%]="progress"
    ></div>
</div>